import type React from 'react';
import './auth-layout.css';

interface AuthLayoutProps {
  kicker?: string;
  title: string;
  hint?: React.ReactNode;
  showDemoCta?: boolean;
  children: React.ReactNode;
}

/**
 * Layout visual del nuevo diseño de ingreso (IPB-821): panel de marca a la
 * izquierda y tarjeta de formulario a la derecha. Solo presentación, sin lógica.
 */
const AuthLayout: React.FC<AuthLayoutProps> = ({
  kicker = 'Gestión de contenidos audiovisuales',
  title,
  hint,
  showDemoCta = false,
  children,
}) => {
  return (
    <div className="ipb-auth">
      <aside className="brand">
        <div className="brand-top">
          <span className="brand-plaque">
            <img className="brand-logo" src="/assets/logo_white.png" alt="IP Broadcast" />
          </span>
          <span className="onair">ON AIR</span>
        </div>
        <div className="brand-mid">
          <h1>
            Cada señal al aire, <b>capturada y lista para publicar.</b>
          </h1>
          <p className="sub">
            Graba señales de TV y streaming en vivo, transcribe con inteligencia artificial y convierte emisiones en
            clips listos para tus redes — sin esperar a que termine el programa.
          </p>
          <ul className="feats">
            <li>Grabación de señales ilimitadas, en vivo y en simultáneo.</li>
            <li>Transcripción automática 24/7, en múltiples idiomas.</li>
            <li>Extracción inteligente de clips y momentos clave.</li>
            <li>Alertas por WhatsApp y correo cuando lo tuyo sale al aire.</li>
          </ul>
        </div>
        <div className="brand-foot">Parte del ecosistema IP Suite</div>
        <div className="vu" aria-hidden="true">
          <i></i>
          <i></i>
          <i></i>
          <i></i>
          <i></i>
          <i></i>
          <i></i>
        </div>
      </aside>

      <main className="form-side">
        <div className="card">
          <p className="kicker">{kicker}</p>
          <h2>{title}</h2>
          {hint && <p className="hint">{hint}</p>}

          <div className="card-body">{children}</div>

          {showDemoCta && (
            <>
              <div className="divide">¿Aún no usas IP Broadcast?</div>
              <p className="demo-cta">
                Mira la plataforma en acción.{' '}
                <a href="https://broadcast-ip.com" target="_blank" rel="noopener noreferrer">
                  Solicita una demo
                </a>
              </p>
            </>
          )}

          <div className="card-foot">
            <div className="legal">
              <a href="/Terms" target="_blank" rel="noopener noreferrer">
                Términos y condiciones
              </a>
              <a href="/Privacy" target="_blank" rel="noopener noreferrer">
                Políticas de seguridad
              </a>
              <a href="https://broadcast-ip.com" target="_blank" rel="noopener noreferrer">
                Sitio web
              </a>
              <a href="https://wa.me/51975026008" target="_blank" rel="noopener noreferrer">
                WhatsApp
              </a>
              <a href="mailto:contacto@suiteintellplat.com?subject=Soporte%20IP%20Broadcast">Soporte</a>
            </div>
            <div className="cf-row">
              <span>© 2026 IP Broadcast · Intelligent Platforms</span>
              <span>Nube u on-premise</span>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AuthLayout;
